import MainStore from "@/store";
import MainRouter from "@/router";

import localStore from "./store";
import localRoutes from "./router";

MainStore.registerModule("exclusiveClub", localStore);
localRoutes.forEach(function (route) {
  MainRouter.addRoute(route);
});
